/**
 * Where the lobby is drawn, which is what sets its scale:
 *
 * - `phone`: a participant's phone or tablet, in the in-person frame;
 * - `desktop`: a laptop - the trainer's, or a participant's;
 * - `room`: the projector, read from the back of a room.
 */
export type LobbySize = 'phone' | 'desktop' | 'room'

type Scale = {
	/** Heading, in px. The desktop heading grows from 1280px up. */
	heading: number
	/** The training under it. */
	meta: number
	/** Body text: facts, step titles, the status. */
	body: number
	/** Secondary text: step descriptions, counts. */
	small: number
	/** Avatars and step markers. */
	badge: number
}

export const SCALE: Record<LobbySize, Scale> = {
	phone: { heading: 24, meta: 14, body: 15, small: 13, badge: 32 },
	desktop: { heading: 28, meta: 16, body: 16, small: 14, badge: 36 },
	room: { heading: 56, meta: 28, body: 26, small: 22, badge: 56 },
}

/** The desktop heading, from 1280px up where the card has two columns. */
export const DESKTOP_WIDE_HEADING = 36
